import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import './sort.css'
createApp(App).mount('#app')
